<template>
  <div class="ua-flag-team-data">
    <div class="top-tab">
      <div class="tab-item" :class="{ active: dataType === 'offensive' }" @click="updateType('offensive')">进攻数据</div>
      <div class="tab-item" :class="{ active: dataType === 'defensive' }" @click="updateType('defensive')">防守数据</div>
    </div>

    <div class="table-title">
      <div class="th-team">球队</div>
      <div class="th-num">总分数</div>
      <div class="th-num">传球达阵</div>
      <div class="th-num">跑球达阵</div>
      <div class="th-num">传球数码</div>
    </div>

    <div v-if="teamStatsList.length === 0" class="empty">还没有相关赛事数据，组委会正在录入中</div>
    <div v-else class="list">
      <div class="row" v-for="item in teamStatsList" :key="item.id">
        <div class="cell team">
          <img class="badge" :src="filterImage(item.badge, 40, 40, 2)" alt="" />
          <span class="name overflow-text">{{ item.name }}</span>
        </div>
        <div class="cell num">{{ formatStat(item.stats, 'score') }}</div>
        <div class="cell num">{{ formatStat(item.stats, 'passingTD') }}</div>
        <div class="cell num">{{ formatStat(item.stats, 'rushingTD') }}</div>
        <div class="cell num">{{ formatStat(item.stats, 'passingYds') }}</div>
      </div>
    </div>

    <div class="match-note">赛事数据统计由组委会提供</div>
  </div>
</template>

<script>
import { getBMRugbyMatchTeamStats } from '@/api/match'
import { QNImageUtil } from '@/utils'

export default {
  name: 'UaFlagTeamDataPage',
  data() {
    return {
      matchId: null,
      dataType: 'offensive',
      teamStatsList: []
    }
  },
  mounted() {
    this.matchId = this.$route.params.matchId || this.$route.query.matchId
    if (!this.matchId) return
    this.getBMRugbyMatchTeamStats()
  },
  methods: {
    getBMRugbyMatchTeamStats() {
      getBMRugbyMatchTeamStats({
        matchId: this.matchId,
        pageSize: 500,
        index: this.dataType
      }).then(res => {
        this.teamStatsList = res.data.teamStatsList || []
      })
    },
    updateType(type) {
      if (this.dataType === type) return
      this.dataType = type
      this.getBMRugbyMatchTeamStats()
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    formatStat(stats, key) {
      if (!stats || stats[key] === undefined || stats[key] === null) return '-'
      const v = stats[key]
      if (v === -1) return '-'
      return v
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ua-flag-team-data {
  min-height: 100%;
  background: #000;
  color: #fff;
  padding: 0 16px 18px;
  box-sizing: border-box;
}

.top-tab {
  display: flex;
  justify-content: space-between;
  padding: 14px 0 10px;
  position: sticky;
  top: 0;
  background: #000;
  z-index: 5;
}

.tab-item {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.55);
  padding: 10px 0;
  border-bottom: 2px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}

.tab-item.active {
  color: #fff;
  border-bottom-color: #ff682c;
}

.table-title {
  display: flex;
  align-items: center;
  padding: 12px 6px;
  font-size: 12px;
  color: #acacac;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.th-team {
  text-align: center;
  flex: 1.3;
}

.th-num {
  flex: 0.7;
  text-align: center;
}

.list {
  padding-top: 8px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 12px;
  margin-top: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.10);
}

.cell {
  font-size: 13px;
  color: #fff;
  text-align: center !important;
}

.team {
  flex: 1.3;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.badge {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.name {
  font-size: 16px;
  font-weight: 500;
}

.num {
  flex: 0.7;
  text-align: right;
  font-size: 13px;
}

.empty {
  text-align: center;
  padding: 32px 16px;
  font-size: 14px;
  color: #b4b4bf;
}

.match-note {
  font-size: 12px;
  color: #6e6e78;
  text-align: center;
  padding: 18px 8px 0;
}
</style>
